import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSessionUser } from "../actions";
import { getSession } from "../selectors";
import { DigitalToolsUser } from "@/types";

interface HookReturn {
  user: DigitalToolsUser | undefined;
  loading: boolean;
}

export const useSession = (): HookReturn => {
  const { user, loading } = useSelector(getSession);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) {
      dispatch(getSessionUser.request());
    }
  }, [user]);

  return { user, loading };
};
